<div class="settings-panel">
  <div class="head">
    <div class="description">
      <div class="title">{{ PANELS.INTEGRATIONS.name }}</div>
      <div class="subtitle">
        {{ PANELS.INTEGRATIONS.description }}
      </div>
    </div>
  </div>

  <div class="panel-body">
    <form [formGroup]="form" (submit)="submitChanges()" class="settings-panel-form">
      <mat-tab-group
        color="primary"
        class="integrations-settings-tabs"
        [disableRipple]="true"
        animationDuration="1ms"
      >
        <!-- API Tab (API_AND_WEBHOOKS capability) -->
        <mat-tab *appSettingsTabVisible="TabId.API">
          <ng-template mat-tab-label>
            <span (click)="onTabClick($event, TabId.API)">{{ 'API' | translate }}</span>
          </ng-template>
          <ng-template matTabContent>
            <app-user-settings-integrations-api [form]="form"></app-user-settings-integrations-api>
          </ng-template>
        </mat-tab>
        <!-- Webhooks Tab (API_AND_WEBHOOKS capability) -->
        <mat-tab *appSettingsTabVisible="TabId.WEBHOOKS">
          <ng-template mat-tab-label>
            <span (click)="onTabClick($event, TabId.WEBHOOKS)">{{ 'Webhooks' | translate }}</span>
          </ng-template>
          <ng-template matTabContent>
            <app-user-settings-integrations-webhooks></app-user-settings-integrations-webhooks>
          </ng-template>
        </mat-tab>
        <!-- LTI Tab -->
        <mat-tab *appSettingsTabVisible="TabId.LTI">
          <ng-template mat-tab-label>
            <span (click)="onTabClick($event, TabId.LTI)">{{ 'LTI' | translate }}</span>
          </ng-template>
          <ng-template matTabContent>
            <app-user-settings-lti [form]="form"></app-user-settings-lti>
          </ng-template>
        </mat-tab>
        <!-- LMS & SIS Tab (LMS_AND_SIS capability) -->
        <mat-tab *appSettingsTabVisible="TabId.LMS_AND_SIS">
          <ng-template mat-tab-label>
            <span (click)="onTabClick($event, TabId.LMS_AND_SIS)">{{
              'LMS & SIS' | translate
            }}</span>
          </ng-template>
          <ng-template matTabContent>
            <app-user-settings-integrations-edlink></app-user-settings-integrations-edlink>
          </ng-template>
        </mat-tab>
      </mat-tab-group>

      <div class="foot" [class.show]="(formState$ | async) !== FormState.Initial">
        <app-pencil-button
          class="pencil-button btn-ok"
          [buttonType]="'submit'"
          [disabled]="
            (formState$ | async) === FormState.ChangedAndInvalid ||
            (formState$ | async) === FormState.Loading
          "
        >
          <span *ngIf="(formState$ | async) !== FormState.Loading" class="material-icons"
            >check</span
          >
          <mat-spinner
            *ngIf="(formState$ | async) === FormState.Loading"
            [diameter]="16"
            color="#FFF"
          ></mat-spinner>
          <span>{{ 'Update' | translate }}</span>
        </app-pencil-button>

        <app-pencil-button
          [buttonType]="'button'"
          class="pencil-button btn-cancel"
          (clickEvent)="discardChanges()"
          type="button"
          icon="close"
          [iconConfig]="{ type: 'material-icon' }"
          [label]="'Cancel' | translate"
        >
        </app-pencil-button>
      </div>
    </form>
  </div>
</div>
